import React from 'react';
import { Card, Grid, Typography } from '@material-ui/core';
import { Certification } from 'app/redux/models/Certification.model';
import './UserCertifications.scss';

interface UserCertificationsProps {
    certifications: Certification[];
    loading?: boolean;
}

export function UserCertifications({ certifications, loading = false }: UserCertificationsProps) {

    if(loading) {
        return <Typography className="certifications-empty">Chargement des certifications…</Typography>;
    }

    if(certifications.length === 0) {
        return <Typography className="certifications-empty" data-testid="no-certification">Pas de certification</Typography>;
    }

    const sortedCertifications = [...certifications].sort((first, second) => first.name.localeCompare(second.name));

    return (
        <Grid container spacing={3} direction="row" data-testid="user-certifications">
            {sortedCertifications.map((certification) => <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={certification.id}>
                <Card className="certification-card">
                    {certification.imageUrl
                        ? <img className="certification-image" src={certification.imageUrl} alt={certification.name} />
                        : <div className="certification-image certification-image-placeholder" aria-hidden="true" />
                    }
                    <Typography className="certification-name" variant="subtitle1" component="h3">
                        {certification.name}
                    </Typography>
                </Card>
            </Grid>)}
        </Grid>
    );
}

export default UserCertifications;
